import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ConfigService } from '../../core/config.service';

@Injectable({
  providedIn: 'root',
})
export class UserlaneService {
  public userlaneToggle: Subject<boolean> = new Subject();

  constructor(private configService: ConfigService) { }

  public toggleUserlane(userLaneShown: boolean): void {
    this.userlaneToggle.next(userLaneShown);
    this.configService.setUserLaneShown(userLaneShown);
  }

  public userLaneShown(): boolean {
    return this.configService.userLaneShown.getValue();
  }
}
